import { SvrAPk } from "../../utils/axios";

export const getArchivosDetImg = async (AreaId, grupo) => {
    let res = {};
    try {
      res = await SvrAPk.post("/api/public/archive/getarchivosdetimg", {
        AreaId,
        grupo
      });
    } catch (Error) {
      res = Error;
    }
    return res;
  };
  